// Third-party library imports.
import React from 'react';
import PropTypes from 'prop-types';

// Local repo imports.
import PaletteAction from '../PaletteAction';
import { EMPTY_ARRAY, EMPTY_STRING, NO_OP } from '../../../constants/Constants';
import '../CheckboxPalette.scss';
class PaletteHeader extends React.PureComponent {
  constructor() {
    super(...arguments);
    this.handleActionClick = updatedActionData => {
      const {
        accessor,
        onHeaderActionChange
      } = this.props;
      onHeaderActionChange(accessor, updatedActionData);
    };
    this.getAllRowsAction = () => {
      const {
        content
      } = this.props;
      const flattendAction = {};
      const allActions = content.reduce((acc, row) => [...acc, ...(row === null || row === void 0 ? void 0 : row.actions)], []);
      allActions.forEach(action => {
        const {
          type,
          value,
          disabled
        } = action;
        if (Object.prototype.hasOwnProperty.call(flattendAction, type)) {
          const {
            existingValue,
            existingDisabled
          } = flattendAction[type];
          flattendAction[type] = {
            existingValue: existingValue && value,
            existingDisabled: existingDisabled && disabled
          };
        } else {
          flattendAction[type] = {
            existingValue: value,
            existingDisabled: disabled
          };
        }
      });
      const consolidatedActions = [];
      Object.keys(flattendAction).forEach(key => {
        consolidatedActions.push({
          type: key,
          value: flattendAction[key].existingValue,
          disabled: flattendAction[key].existingDisabled
        });
      });
      return consolidatedActions;
    };
  }
  render() {
    const {
      headerLabel
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: "palette-header-container"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "palette-header palette-words-overflow-control"
    }, headerLabel), /*#__PURE__*/React.createElement(PaletteAction, {
      displayActionLabel: true,
      actions: this.getAllRowsAction(),
      onClickAction: this.handleActionClick
    }));
  }
}
PaletteHeader.propTypes = {
  accessor: PropTypes.string,
  content: PropTypes.array,
  headerLabel: PropTypes.string,
  onHeaderActionChange: PropTypes.func
};
PaletteHeader.defaultProps = {
  accessor: EMPTY_STRING,
  content: EMPTY_ARRAY,
  headerLabel: EMPTY_STRING,
  onHeaderActionChange: NO_OP
};
export default PaletteHeader;